<template>
  <b-card-code
    title="مشخصات دفتر"
  >
    <b-form @submit.prevent>
      <b-row>
        <!-- title -->
        <b-col cols="6">
          <b-form-group
            label="عنوان"
            label-for="vi-title"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-title"
                v-model="office.title"
                placeholder=""
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- city -->
        <b-col cols="6">
          <b-form-group
            label="شهر"
            label-for="vi-city"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-city"
                v-model="office.city"
                placeholder=""
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- address -->
        <b-col cols="6">
          <b-form-group
            label="آدرس"
            label-for="vi-address"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-address"
                v-model="office.address"
                placeholder=""
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- address -->
        <b-col cols="3">
          <b-form-group
            label="عرض جغرافیایی"
            label-for="vi-lat"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-lat"
                v-model="office.lat"
                placeholder="0"
                :readonly="true"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- lon -->
        <b-col cols="3">
          <b-form-group
            label="طول جغرافیایی"
            label-for="vi-lon"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-lon"
                v-model="office.lon"
                placeholder=""
                :readonly="true"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- radius -->
        <b-col cols="6">
          <b-form-group
            label="شعاع"
            label-for="vi-radius"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-radius"
                v-model="office.radius"
                type="number"
                placeholder=""
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- disabled -->
        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox
              id="disabled"
              v-model="office.disabled"
              name="disabled"
              value="true"
            >
              غیرفعال
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <!-- reset and submit -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="submitForm()"
          >
            ذخیره
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            class="mr-1"
            variant="outline-secondary"
          >
            دوباره
          </b-button>
          <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              class="mr-1"
              @click.prevent="onCancel"
              variant="outline-primary"
          >
            لغو
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <l-map
          style="width: 100vw; height: 60vh; direction: ltr; text-align: left"
          :zoom="zoom"
          :center="center"
          :options="{zoomControl: false}"
          @click="addMarker"
        >
          <l-tile-layer
            :url="url"
            :attribution="attribution"
          />

          <l-control-zoom position="bottomright" />
          <l-marker :lat-lng="markerLatLng">
            <l-icon
              :icon-size="dynamicSize"
              :icon-anchor="dynamicAnchor"
              :icon-url="iconUrl"
            />
          </l-marker>

        </l-map>
      </b-row>
    </b-form>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BInputGroup, BInputGroupPrepend, BFormSelect,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LControlZoom, LIcon,
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Office from '@/models/office'

import OfficeService from '@/services/office.service'
import router from '@/router'

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    LMap,
    LTileLayer,
    LControlZoom,
    LMarker,
    LIcon,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      office: new Office(localStorage.getItem('companySelected'), '', '', '', '', '', 50, ''),
      selected: null,
      options: [],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '',
      zoom: 12,
      center: [35.7207423, 51.3230157],
      markerLatLng: [0, 0],
      // eslint-disable-next-line no-undef
      // eslint-disable-next-line global-require
      iconUrl: require('@/assets/images/pngegg.png'),
    }
  },
  computed: {
    dynamicSize() {
      return [50, 50]
    },
    dynamicAnchor() {
      return [25, 50]
    },
  },
  created() {
    if ('id' in this.$route.params) {
      this.getContactById()
    }
  },
  methods: {
    getContactById() {
      OfficeService.getById({ _id: this.$route.params.id }).then(
        res => {
          if (res.status === 'success') {
            this.office = res.result.data
            const event = { latlng: { lat: this.office.lat, lng: this.office.lon } }
            this.addMarker(event)
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    async submitForm() {
      this.office.disabled = this.disabled === 'true'
      OfficeService.add(this.office).then(
        res => {
          if (res.status === 'success') {
            router.push({ path: '/office/list' })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addMarker(event) {
      this.office.lon = event.latlng.lng
      this.office.lat = event.latlng.lat
      this.markerLatLng = event.latlng
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'company-list' })
    },
  },
}
</script>
<style scope>
[dir=rtl] .leaflet-pane, [dir=rtl] .leaflet-tile, [dir=rtl] .leaflet-marker-icon,
[dir=rtl] .leaflet-marker-shadow, [dir=rtl] .leaflet-tile-container, [dir=rtl] .leaflet-pane > svg,
[dir=rtl] .leaflet-pane > canvas, [dir=rtl] .leaflet-zoom-box, [dir=rtl] .leaflet-image-layer, [dir=rtl]

.leaflet-layer {
  right: unset;
}
</style>
